define([
    './FaqDirective',
    './FaqLink',
    './FaqService',
    'edge/platform/widgets/youtube/module',
    'edge/platform/filters/module',
    'edge/platform/featuredetection/module',
    'l10nModule'
], (FaqDirective, FaqLink, FaqService) => {
    return angular.module('edge.platform.faq', [
        'edge.platform.widgets.youtube',
        'edge.platform.filters',
        'edge.platform.featuredetection',
        'edge.platform.l10n'
    ])
        .directive('gwFaq', FaqDirective)
        .directive('gwFaqLink', FaqLink)
        .provider('FaqService', FaqService);
});


// WEBPACK FOOTER //
// ../common/js/src/edge/platform/faq/module.js